module.exports = __webpack_public_path__ + "img/IO.1aa590b6.png";